import type { Entity } from '@/types/entity';

/** 엔티티의 검색 대상 텍스트 (name·alias·summary·필드값) */
export function entityHaystack(e: Entity): string {
  const fieldText = Object.values(e.fields)
    .map((v) => (typeof v === 'string' ? v : Array.isArray(v) ? v.join(' ') : v == null ? '' : String(v)))
    .join(' ');
  return [e.name, ...(e.aliases ?? []), e.summary ?? '', ...(e.tags ?? []), fieldText]
    .join(' ')
    .toLowerCase();
}

export function matchEntity(e: Entity, q: string): boolean {
  const ql = q.trim().toLowerCase();
  if (!ql) return true;
  return entityHaystack(e).includes(ql);
}
